'use client';

import IllustrationMotion from '@/features/empty-state/IllustrationMotion';
import Link from 'next/link';
import './notFound.scss';

function readMessage(messages, path, fallback = '') {
  const resolved = String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((current, segment) => current?.[segment], messages?.notFound);

  return typeof resolved === 'string' ? resolved : fallback;
}

export default function NotFoundState({ messages = {} }) {
  return (
    <section
      className="not-found-state"
      aria-label={readMessage(messages, 'aria', '404 page not found')}
    >
      <div className="not-found-state__media">
        <IllustrationMotion
          src="/images/searchEmpty.jpg"
          alt={readMessage(messages, 'title', 'This page does not exist')}
          maxHeight={320}
          className="not-found-state__illustration"
        />
      </div>

      <div className="not-found-state__content">
        <p className="not-found-state__eyebrow">
          {readMessage(messages, 'eyebrow', 'Lost in the catalog?')}
        </p>
        <h1 className="not-found-state__title">
          {readMessage(messages, 'title', 'This page does not exist')}
        </h1>
        <p className="not-found-state__message">
          {readMessage(
            messages,
            'message',
            'The page may have moved, the link may be outdated, or the route was typed incorrectly. Jump back into the shop or return home.',
          )}
        </p>

        <div className="not-found-state__actions">
          <Link href="/shop" className="app-button app-button--primary">
            {readMessage(messages, 'shopAction', 'Browse the shop')}
          </Link>
          <Link href="/" className="app-button app-button--secondary">
            {readMessage(messages, 'homeAction', 'Back to home')}
          </Link>
        </div>
      </div>
    </section>
  );
}
